import _ from 'lodash';
import angular from 'angular';
import { RECRUITER_WORKFLOW_STATUS } from '../../recruiter/constants/recruiter-workflow';
import { EMPLOYER_WORKFLOW_STATUS } from '../../employer/constants/employer-workflow';

export const CommonCodeService = ($filter, WorkflowService) => {
    const capitalizeName = function (fullname) {
        let capitalizedName = '';
        const nameArr = fullname.split(' ');
        let newTemp;
        let tempFirstCharUpper;
        let tempWithoutFirstLetter;
        for (let i = 0; i < nameArr.length; i++) {
            if (i > 0) {
                capitalizedName += ' ';
            }
            newTemp = '';
            tempFirstCharUpper = '';
            tempWithoutFirstLetter = '';
            tempFirstCharUpper = nameArr[i].charAt(0)
                .toUpperCase();
            tempWithoutFirstLetter = nameArr[i].slice(1);
            newTemp = tempFirstCharUpper + tempWithoutFirstLetter;
            capitalizedName += newTemp;
        }
        return capitalizedName;
    };

    const getLocationString = function (location) {
        let locationString = '';
        if (location) {
            if (location.city) {
                locationString = location.city;
            }
            if (location.region) {
                if (locationString) {
                    locationString += ', ';
                }
                locationString +=
                    (location.region || '');
            }
            if (location.state) {
                if (locationString) {
                    locationString += ', ';
                }
                locationString +=
                    (location.state || '');
            }
            if (location.country) {
                if (locationString) {
                    locationString += ', ';
                }
                locationString +=
                    location.country;
            }
        }
        return locationString;
    };

    const getPosted = function (nowDate, date) {
        let delta = (nowDate - date) / 1000;

        if (delta <= 0) {
            return '0m ago';
        }
        // calculate (and subtract) Year
        const years = Math.floor(delta / 31536000);
        delta -= years * 31536000;

        // calculate (and subtract) Month
        const months = Math.floor(delta / 2592000);
        delta -= months * 2592000;

        // calculate (and subtract) whole days
        const days = Math.floor(delta / 86400);
        delta -= days * 86400;

        // calculate (and subtract) whole hours
        const hours = Math.floor(delta / 3600) % 24;

        // calculate (and subtract) whole minutes
        let ans = '';
        if (years > 0) {
            ans = `${ans + years}y `;
        }
        if (months > 0) {
            ans = `${ans + months}M `;
        }
        if (days > 0) {
            ans = `${ans + days}d `;
        }
        if (hours > 0) {
            ans = `${ans + hours}h `;
        }
        return `${ans}ago`;
    };

    const updateCallForActionForTalent = function ({ talent, isSourcingServicesEnabled, backButtonText, canClaim }) {
        let feedBackStatus = null;
        if (talent && talent.workflow) {
            feedBackStatus = $filter('getCurrentEventType')(talent.workflow.events);
        }

        const isNotHidden = !talent.workflow || (talent.workflow && talent.workflow.recruiterStatus.current !== 'Hidden');
        const isClaimAction = talent.workflow && talent.workflow.recruiterStatus.current === 'Claimed';

        if (backButtonText === 'PROSPECTS' && isNotHidden) {
            talent.currentCallForAction = 'CLAIM';
        } else if (isClaimAction) {
            if (isSourcingServicesEnabled) {
                if (feedBackStatus === WorkflowService.eventTypes.CONFIRM_RESPONSE) {
                    talent.currentCallForAction = 'CONFIRM_RESPONSE';
                } else {
                    talent.currentCallForAction = 'SEND_RESUME_TO_EMP';
                }
            } else if (feedBackStatus === WorkflowService.eventTypes.CONTACT_CANDIDATE) {
                talent.currentCallForAction = 'CONTACT_CAND';
            } else if (feedBackStatus === WorkflowService.eventTypes.CONFIRM_RESPONSE) {
                talent.currentCallForAction = 'CONFIRM_RESPONSE';
            } else if (feedBackStatus === WorkflowService.eventTypes.REQUEST_FEEDBACK) {
                talent.currentCallForAction = 'REQUEST_FEEDBACK';
            }
        } else if (talent.workflow) {
            const currentWorkflowStatus = talent.workflow.recruiterStatus.current;

            if (currentWorkflowStatus === RECRUITER_WORKFLOW_STATUS.ENGAGED) {
                const engagedStep = WorkflowService.getCandidateWorkflowEngagedStep(talent.workflow);

                switch (engagedStep) {
                    case WorkflowService.engagedSteps.RESUME_APPROVED:
                        talent.currentCallForAction = 'APPROVE_SUBMISSION';
                        break;
                    case WorkflowService.engagedSteps.RESUME_SENT:
                        talent.currentCallForAction = 'WAITING_FOR_CANDIDATE_APPROVAL';
                        break;
                    case WorkflowService.engagedSteps.RESUME_CREATED:
                        talent.currentCallForAction = 'SEND_RESUME_TO_CANDIDATE';
                        break;
                    case WorkflowService.engagedSteps.NONE:
                        talent.currentCallForAction = _.findIndex(
                            talent.workflow.events,
                            { eventType: WorkflowService.eventTypes.INTERVIEW_CREATED },
                        ) >= 0 ? 'CREATE_RESUME_FOR_EMPLOYER' : 'INTERVIEW';
                        break;
                }
            }

            if (currentWorkflowStatus === RECRUITER_WORKFLOW_STATUS.READY) {
                talent.currentCallForAction = 'SEND_RESUME_TO_EMP';
            }

            if (currentWorkflowStatus === RECRUITER_WORKFLOW_STATUS.REJECTED
                         && talent.workflow.employerStatus.current !== EMPLOYER_WORKFLOW_STATUS.REJECTED
                         && (canClaim || [
                             RECRUITER_WORKFLOW_STATUS.PROSPECT,
                             RECRUITER_WORKFLOW_STATUS.HIDDEN,
                         ].indexOf(talent.workflow.recruiterStatus.history[0].status) >= 0)) {
                talent.currentCallForAction = 'BACK_TO_PREV_STATUS';
            }

            if (currentWorkflowStatus === RECRUITER_WORKFLOW_STATUS.HIDDEN) {
                talent.currentCallForAction = 'BACK_TO_PROSPECTS';
            }
        }
    };

    const updateCallForActionForTalents = function (searchCtrl, isNewSearch) {
        const start = isNewSearch ? 0 : (searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage;
        const length = isNewSearch ? searchCtrl.filteredCandidates.resultList.length : searchCtrl.currentPage * searchCtrl.candidatesPerPage;

        for (let i = start; i < length; i++) {
            const talent = searchCtrl.filteredCandidates.resultList[i];
            if (!talent) {
                return;
            }
            const searchData = searchCtrl.searchData;
            const positionData = searchData.positionData;
            const isSourcingServicesEnabled = positionData.employerContactCandidates;
            const { backButtonText, canClaim } = searchCtrl;
            updateCallForActionForTalent({
                talent,
                isSourcingServicesEnabled,
                backButtonText,
                canClaim,
            });
        }
    };

    const generateRandomColor = function () {
        function rgb(string) {
            return string.match(/\w\w/g)
                .map(b => parseInt(b, 16));
        }

        const rgb1 = rgb('#000000');
        const rgb2 = rgb('#c1c1c1');

        const rgb3 = [];
        for (let i = 0; i < 3; i++) rgb3[i] = rgb1[i] + Math.random() * (rgb2[i] - rgb1[i]) | 0;

        return `#${rgb3
            .map(n => n.toString(16))
            .map(s => '00'.slice(s.length) + s)
            .join('')}`;
    };

    const setStartCase = fullname => _.chain(fullname).toLower().startCase().value();

    const setStartCaseAndGetFirst = fullname => _.chain(setStartCase(fullname)).split(' ').first().value();

    const getLocationData = (position) => {
        const locations = _.get(position, 'locations', []);
        const additionalLocations = [...locations].splice(1);

        // todo after migration remove this
        const main = getLocationString(locations[0] || position.location);
        const additional = additionalLocations.length
            ? additionalLocations.map(location => getLocationString(location)).join('; ') : '';
        const additionalTemplate = additionalLocations.length
            ? additionalLocations.map(location => `<div>${getLocationString(location)}</div>`).join('') : '';
        const additionalCount = additionalLocations.length;

        return {
            main,
            additional,
            additionalCount,
            additionalTemplate: `<span>${additionalTemplate}</span>`,
        };
    };

    return {
        capitalizeName,
        getLocationString,
        getPosted,
        updateCallForActionForTalent,
        updateCallForActionForTalents,
        generateRandomColor,
        setStartCase,
        setStartCaseAndGetFirst,
        getLocationData,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CommonCodeService', CommonCodeService);
